interface Props {
  onStart: () => void;
}

export default function LiteracyIntro({ onStart }: Props) {
  return (
    <div className="max-w-2xl mx-auto">
      {/* Hero Card */}
      <div className="bg-primary-500 rounded-2xl p-8 md:p-10 text-white text-center mb-6">
        <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mx-auto mb-5">
          <i className="ri-book-read-line text-3xl text-white"></i>
        </div>
        <h1 className="font-heading text-2xl md:text-3xl font-bold mb-3">
          어휘력·문해력 검사
        </h1>
        <p className="text-primary-100 text-sm md:text-base leading-relaxed">
          일상 어휘부터 뉴스 속 시사·경제·과학·예술·정치·문화 어휘까지 어휘력을 점검하고,
          <br className="hidden md:block" />
          다양한 지문을 읽고 내용을 파악하는 문해력을 함께 평가해 드립니다.
        </p>
      </div>

      {/* Info Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        {[
          { icon: 'ri-time-line', title: '소요 시간', value: '약 20~25분' },
          { icon: 'ri-question-answer-line', title: '문항 수', value: '총 164문항' },
          { icon: 'ri-bar-chart-2-line', title: '평가 영역', value: '어휘력·문해력' },
        ].map((item) => (
          <div key={item.title} className="bg-background-50 border border-background-200 rounded-xl p-4 text-center">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg mx-auto mb-2">
              <i className={`${item.icon} text-primary-600`}></i>
            </div>
            <div className="font-bold text-foreground-950">{item.value}</div>
            <div className="text-xs text-foreground-500 mt-0.5">{item.title}</div>
          </div>
        ))}
      </div>

      {/* 어휘력 영역 */}
      <div className="bg-background-50 border border-background-200 rounded-xl p-6 mb-6">
        <h3 className="font-semibold text-foreground-950 mb-1 flex items-center gap-2">
          <i className="ri-font-size text-accent-500"></i>
          어휘력 검사
        </h3>
        <p className="text-foreground-600 text-sm mb-4 leading-relaxed">
          각 유형별 20문항, 총 140문항. 단어의 뜻을 정확히 알고 있는지 확인합니다.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          {['일상', '시사', '경제', '과학', '예술', '정치', '문화'].map((cat) => (
            <div key={cat} className="border border-background-200 rounded-lg px-3 py-2 text-center">
              <div className="font-semibold text-foreground-900 text-sm">{cat}</div>
              <div className="text-xs text-foreground-500">20문항</div>
            </div>
          ))}
        </div>
      </div>

      {/* 문해력 영역 */}
      <div className="bg-background-50 border border-background-200 rounded-xl p-6 mb-6">
        <h3 className="font-semibold text-foreground-950 mb-1 flex items-center gap-2">
          <i className="ri-file-text-line text-accent-500"></i>
          문해력 검사
        </h3>
        <p className="text-foreground-600 text-sm mb-4 leading-relaxed">
          지문을 읽고 내용을 파악하는 능력을 확인합니다. 각 유형별 4문항, 총 24문항.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {['일상', '시사', '경제', '과학기술', '문화예술', '인문'].map((cat) => (
            <div key={cat} className="border border-background-200 rounded-lg px-3 py-2 text-center">
              <div className="font-semibold text-foreground-900 text-sm">{cat}</div>
              <div className="text-xs text-foreground-500">4문항</div>
            </div>
          ))}
        </div>
      </div>

      {/* Notice */}
      <div className="bg-accent-50 border border-accent-200 rounded-xl p-4 mb-6">
        <div className="flex gap-2">
          <i className="ri-information-line text-accent-500 flex-shrink-0 mt-0.5"></i>
          <p className="text-accent-700 text-sm leading-relaxed">
            이 검사는 <strong>어휘력</strong>과 <strong>문해력</strong>을 스스로 점검하기 위한 참고용 검사입니다.
            어휘력 140문항을 먼저 풀고, 이어서 문해력 24문항을 풀게 됩니다. 정식 언어능력 평가를 대체하지 않습니다.
          </p>
        </div>
      </div>

      <button
        onClick={onStart}
        className="whitespace-nowrap w-full bg-primary-500 hover:bg-primary-600 text-white font-bold py-4 rounded-xl text-base transition-colors cursor-pointer"
      >
        검사 시작하기 <i className="ri-arrow-right-line ml-2"></i>
      </button>
    </div>
  );
}